import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=3592e41d&scoped=true"
import script from "./table-view.vue?vue&type=script&lang=js"
export * from "./table-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592e41d",
  null
  
)

export default component.exports